import React from 'react';
import Typography from 'carbon-react/lib/components/typography';
import { FormattedMessage } from 'react-intl';

import { Organisation } from '@futrli-sdk/organisations';
import { Integration } from '@futrli-sdk/app-store';

import * as styles from './sync-data-card.scss';
import { SyncDataCardDivider } from './sync-data-card-divider';
import { SyncContentLoader } from '../sync-content-loader/sync-content-loader';
import { SyncDataOrgDetails } from './sync-data-org-details';

interface Props {
  organisation: Organisation | null;
  integration?: Integration;
}

export const SyncDataCardLoaderPlaceholder = ({ organisation, integration }: Props) => (
  <>
    <div>
      <SyncDataOrgDetails organisation={organisation} integration={integration} />
      <SyncDataCardDivider />
      <div className={styles.syncStatusRow}>
        <div>
          <Typography variant="p" mb="4px" color="rgba(0, 0, 0, 0.65)">
            <FormattedMessage id="common.sync_status" defaultMessage="Sync status" />
          </Typography>
          <SyncContentLoader width={64} height={16} />
        </div>
        <div>
          <Typography variant="p" mb="4px" color="rgba(0, 0, 0, 0.65)">
            <FormattedMessage id="common.last_synced" defaultMessage="Last synced" />
          </Typography>
          <SyncContentLoader width={64} height={16} />
        </div>
      </div>
      <SyncDataCardDivider />
    </div>
    <div style={{ margin: '16px 0' }} data-testid="sync-loading-bank-transactions">
      <Typography variant="p" mb="4px" color="rgba(0, 0, 0, 0.65)">
        <FormattedMessage id="common.bank_transactions" defaultMessage="Bank transactions" />
      </Typography>
      <SyncContentLoader width="60%" height={16} />
    </div>
  </>
);
